import { useToast, VStack, Heading, Button } from "@chakra-ui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import z from "zod";
import { SectionTitle } from "../../../components/atoms/Title";
import { useRecoveryMutation } from "../../../service/auth/hooks";
import { isAuthenticated } from "../../../service/axios";
import { useTheme } from "../../../contexts/ThemeProvider";
import { Text } from "../../../components/atoms/Text";
import { Input } from "@/components/atoms/Input";

export function RecoveryForm({ setIsSended }: { setIsSended: (value: boolean) => void }) {
  const navigate = useNavigate();
  const { id } = useTheme();
  const toast = useToast({ isClosable: true });

  const formSchema = z.object({
    username: z.string(),
  });

  const methods = useForm({
    resolver: zodResolver(formSchema),
  });

  const { control, handleSubmit } = methods;

  const isEmail = (value: string) => /\S+@\S+\.\S+/.test(value);

  const recoveryMutation = useRecoveryMutation({
    agreementId: id ? id : undefined,
    onSuccess() {
      setIsSended(true);
    },
    onError(error) {
      toast({ title: 'Oops!', description: error, status: 'error' });
    },
  });

  if (isAuthenticated()) navigate('/');

  return (
    <VStack w={'100%'} spacing={7}>
      <VStack w={'100%'} align={'flex-start'} spacing={4}>
        <Heading fontWeight={700} letterSpacing={'-0.045em'} fontFamily={'Glory'} fontSize={'36px'}>
          Recuperar Senha
        </Heading>
        <SectionTitle display={'flex'} gap={1} flexDir="row" fontSize={14} fontWeight={600}>
          <Text fontSize={14}>Esqueceu sua senha? Insira o seu e-mail abaixo para lhe enviarmos uma nova!</Text>
        </SectionTitle>
      </VStack>
      <form
        onSubmit={handleSubmit(({ username }) => {
          if (isEmail(username)) {
            recoveryMutation.mutate({ email: username });
          } else {
            toast({ title: 'Erro', description: 'Por favor, insira um email válido.', status: 'error' });
          }
        })}
        style={{ width: '100%' }}
      >
        <VStack w={'100%'} spacing={7}>
          <VStack w={'100%'} spacing={4}>
            <Input control={control} name="username" label={'Email'} autoComplete="off" />
          </VStack>

          <Button type="submit" isLoading={recoveryMutation.isLoading}>
            Recuperar
          </Button>
        </VStack>
      </form>
    </VStack>
  );
}
